import React from 'react';
import { TextTitle as OriginalTextTitle } from '@bingads-webui-campaign/wizard-jumbo-card';
import { useDefaultStyles } from '@bingads-webui-react/with-default-styles';
import { getPannelHeaderStyles } from './styles/collapsible-panel';

const PannelHeader = (props) => {
  const classes = useDefaultStyles(getPannelHeaderStyles);

  return (
    <h3 className={classes.pannelHeader}>{props.children}</h3>
  );
};

export const TextTitle = props => <OriginalTextTitle {...props} as={PannelHeader} />;
